import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import Wrapper from "../components/Wrapper.js";
import Api from "../Api.js";
import {Col, Row} from "react-bootstrap";
import userbig from "../assets/img/userbig.png";
import {word} from '../word.js';
import OrganizationItem from "../components/OrganizationItem.js";
function UserSingle(props) {
    const {id} = useParams()
    const [client,setClient] = useState({})
    const [loading,setLoading] = useState(false)
    useEffect(() => {
        (async () => {
            try{
                const {data} = await Api.clientSingle(id)
                setClient(data)
                setLoading(false)
            }catch (e) {

            }
        })()
    },[id])
    return (
        <Wrapper>
            <div className="my-user-org-page">
                <div className="header-line"/>
                <div className="modules-header"/>
                <div className="my-page-cont">
                    <div className="container">
                        <Row className="img-name">
                            <div className="image-round">
                                <div
                                    className="my-personal-image"
                                    style={{
                                        backgroundImage: client?.image
                                            ? `url(${client?.image})`
                                            : `url(${userbig})`,
                                    }}
                                />
                            </div>
                            <h1>
                                {client?.user?.first_name}
                                <br /> {client?.user?.last_name}
                            </h1>
                        </Row>

                        <div className="data-section">
                            <div className="container">
                                <p className="data-section">{word.personal_information}</p>
                                <Row className="my-data">
                                    <Col xs={6} sm={6}>
                                        <p className="data-line">{word._name}</p>
                                        <p className="data-line">{word.surname}</p>
                                        <p className="data-line">{word.phone}</p>
                                        <p className="data-line">{word.email}</p>
                                    </Col>
                                    <Col xs={6} sm={6}>
                                        <p className="data-line">
                                            <span>{client?.user?.first_name}</span>
                                        </p>
                                        <p className="data-line">{client?.user?.last_name}</p>
                                        <p className="data-line">{client?.phone}</p>
                                        <p className="data-line">{client?.user?.email}</p>
                                    </Col>
                                </Row>

                                <p className="data-section">{word.my_organizations}</p>
                                <div className="org-section">
                                    {client?.client_company
                                        ?.filter((item) => !item?.is_deleted_by_manager)
                                        .map((item, index) => (
                                            <div key={index}>
                                                <OrganizationItem
                                                    id={item?.id}
                                                    is_deleted={item?.is_deleted}
                                                    orgname={item?.name}
                                                    name={item?.director_full_name}
                                                    HVHH={item?.HVHH}
                                                    logo={item?.logo}
                                                />
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
}

export default UserSingle;